<template>
  <div class="contenido">
    <h2 class="pl-3">{{ father }} | Materias Previas</h2>
    <v-dialog v-model="dialogDetallePrevia" width="800px">
      <v-card style="overflow:hidden;">
        <v-card-title class="grey lighten-4 py-4 title"
          >Detalle de Previa</v-card-title
        >
        <v-row align-center justify="center" class="text-center">
          <v-col>
            <label>{{ mayus(textoDetalleDialog) }}</label>
          </v-col>
        </v-row>
        <v-row align-center justify="center" class="text-center">
          <v-col cols="11">
            <v-row>
              <v-col cols="2" class="header">Nota</v-col>
              <v-col cols="2" class="header">Periodo</v-col>
              <v-col cols="2" class="header">Fecha</v-col>
              <v-col cols="2" class="header">Libro de Acta</v-col>
              <v-col cols="2" class="header">Tomo</v-col>
              <v-col cols="2" class="header">Folio</v-col>
            </v-row>
            <template v-for="detalle in previaDetalle">
              <v-row :key="detalle.idprevia_nota">
                <v-col cols="2" class="borde_inferior">{{
                  detalle.nota
                }}</v-col>
                <v-col cols="2" class="borde_inferior">{{
                  detalle.periodo
                }}</v-col>
                <v-col cols="2" class="borde_inferior">{{
                  detalle.fecha
                }}</v-col>
                <v-col cols="2" class="borde_inferior">{{
                  detalle.libro_acta
                }}</v-col>
                <v-col cols="2" class="borde_inferior">{{
                  detalle.tomo
                }}</v-col>
                <v-col cols="2" class="borde_inferior">{{
                  detalle.folio
                }}</v-col>
              </v-row>
            </template>
          </v-col>
        </v-row>
        <v-row>
          <v-col class="text-center btn_dialog">
            <v-btn
              color="primary"
              @click="dialogDetallePrevia = !dialogDetallePrevia"
              >Aceptar</v-btn
            >
          </v-col>
        </v-row>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogNotaPrevia" width="800px">
      <v-card style="overflow:hidden;">
        <v-card-title class="grey lighten-4 py-4 title"
          >Nueva nota de materia previa</v-card-title
        >
        <v-row align-center justify="center" class="text-center">
          <v-col>
            <label>{{ mayus(textoDetalleDialog) }}</label>
          </v-col>
        </v-row>
        <v-row align-center justify="center" class="text-center">
          <v-col cols="11">
            <v-row>
              <v-col cols="2" class="header">Nota</v-col>
              <v-col cols="2" class="header">Periodo</v-col>
              <v-col cols="2" class="header">Fecha</v-col>
              <v-col cols="2" class="header">Libro de Acta</v-col>
              <v-col cols="2" class="header">Tomo</v-col>
              <v-col cols="2" class="header">Folio</v-col>
            </v-row>
            <v-row align-center justify-center class="btn_dialog">
              <v-col cols="2">
                <input
                  type="text"
                  class="elevation-3"
                  placeholder="-"
                  :value="formato_numero()"
                  @keypress="soloNumeros"
                  ref="n_nota"
                />
              </v-col>
              <v-col cols="2">
                <input
                  type="text"
                  class="elevation-3 deshabilitado"
                  placeholder="-"
                  ref="n_periodo"
                  readonly
                  :value="periodo"
                />
              </v-col>
              <v-col cols="2">
                <!--<datePicker :label="'fecha nota'" :fechaMaxima="hoy" ref="n_fecha" />-->
              </v-col>
              <v-col cols="2">
                <input
                  type="text"
                  class="elevation-3"
                  placeholder="-"
                  ref="n_libro_acta"
                />
              </v-col>
              <v-col cols="2">
                <input
                  type="text"
                  class="elevation-3"
                  placeholder="-"
                  ref="n_tomo"
                />
              </v-col>
              <v-col cols="2">
                <input
                  type="text"
                  class="elevation-3"
                  placeholder="-"
                  ref="n_folio"
                />
                <input type="hidden" ref="n_idprevia" />
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <v-row align-center justify="center">
          <v-col class="text-center btn_dialog">
            <label
              class="msj_error_nota"
              ref="msj_nota"
              :class="[!msj_error_visible ? 'oculto' : '']"
              >La nota deber tener un valor entre 0 y 10</label
            >
          </v-col>
        </v-row>
        <v-row align-center justify="center">
          <v-col class="text-center btn_dialog shrink">
            <v-btn color="primary" @click="dialogNotaPrevia = !dialogNotaPrevia"
              >Cancelar</v-btn
            >
          </v-col>
          <v-col class="text-center btn_dialog shrink">
            <v-btn color="success" @click="guardarNotaDePrevia"
              >Agregar Nota</v-btn
            >
          </v-col>
        </v-row>
      </v-card>
    </v-dialog>
    <template>
      <v-card class="pa-3 ma-3">
        <v-row>
          <v-col cols="3" justify="end">
            <v-btn color="success" @click="check">Añadir Materia Previa</v-btn>
          </v-col>
        </v-row>
        <v-card-title>
          <v-row justify="center">
            <v-col cols="6">
              <v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                label="Buscar"
                single-line
                hide-details
              ></v-text-field>
            </v-col>
          </v-row>
        </v-card-title>

        <v-data-table
          :headers="headers"
          :items="previas"
          :search="search"
          :loading="loadingDataPrevias"
          ref="lista_previas"
          loading-text="Cargando... Por favor espere"
        >
          <template v-slot:item.edit="{ item }">
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-icon
                  v-on="on"
                  @click="
                    mostrarDialogoDeCargaDeNota(
                      item.idprevia,
                      item.alumno +
                        ' (Dni: ' +
                        item.dni +
                        ') -> ' +
                        item.nombre +
                        ' ' +
                        item.curso
                    )
                  "
                  >mdi-pencil</v-icon
                >
              </template>
              <span>Cargar Nota</span>
            </v-tooltip>
          </template>

          <template v-slot:item.mas="{ item }">
            <template v-if="item.can_notas > 0">
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-icon
                    v-on="on"
                    @click="
                      obtenerNotasMateriaPrevia(
                        item.idprevia,
                        item.alumno +
                          ' (Dni: ' +
                          item.dni +
                          ') -> ' +
                          item.nombre +
                          ' ' +
                          item.curso
                      )
                    "
                    >mdi-magnify</v-icon
                  >
                </template>
                <span>Ver Más</span>
              </v-tooltip>
            </template>
          </template>

          <template v-slot:no-data>
            <div
              class="text-center"
              :class="[
                !loadingDataPrevias && previas.length == 0
                  ? 'visible'
                  : 'oculto'
              ]"
            >
              No hay Personas Cargadas
            </div>
            <div
              class="text-center"
              :class="[loadingDataPrevias ? 'visible' : 'oculto']"
            >
              Cargando... Por favor espere
            </div>
          </template>
        </v-data-table>
      </v-card>
    </template>
  </div>
</template>

<script>
import moment from "moment";

import API from "@/components/_config/conf";
//import datePicker from "@/components/_config/fecha";

export default {
  data() {
    return {
      loadingDataPrevias: false,
      dialogDetallePrevia: false,
      dialogNotaPrevia: false,
      textoDetalleDialog: "",
      msj_error_visible: false,
      search: "",
      hoy: moment().format("YYYY-MM-DD"),
      periodo: moment().format("YYYY"),
      headers: [
        {
          text: "Alumno",
          sortable: true,
          value: "alumno"
          //class: "headerGrid"
        },
        { text: "Dni", sortable: false, class: "", value: "dni" },
        { text: "Materia", sortable: false, class: "", value: "nombre" },
        { text: "Curso", sortable: false, class: "", value: "curso" },
        {
          text: "Establecimiento",
          sortable: false,
          class: "",
          value: "establecimiento"
        },
        { text: "Periodo", sortable: false, class: "", value: "periodo" },
        {
          text: "Cant. Notas",
          sortable: false,
          class: "text-xs-center",
          value: "can_notas"
        },
        { text: "", value: "edit", sortable: false, width: 50 },
        { text: "", value: "mas", sortable: false, width: 50 }
      ],
      previas: [],
      previaDetalle: []
    };
  },
  props: ["father"],
  components: {
    //datePicker
  },
  mounted: function() {
    this.obtenerMateriasPrevias();
    //console.log("materiasDocente -> Mounted !");
  },
  methods: {
    mayus(str) {
      let srt_result = API.ucFirst(str);
      return srt_result;
    },
    soloNumeros(e) {
      var key = window.event ? e.which : e.keyCode;
      if ((key < 48 || key > 57) && key != 46) {
        e.preventDefault();
      }
    },
    formato_numero: function(numero) {
      if (!isNaN(numero) && numero <= 10) {
        if (numero == 0) {
          numero = "AUS";
        } else {
          numero = parseFloat(numero).toFixed(2);
        }
        return numero;
      } else return "";
    },
    obtenerMateriasPrevias() {
      this.loadingDataPrevias = true;
      let resultado = API.enviar("get", "obtenerMateriasPreviasActivas", "");
      //console.log(this.alumnos.length, this.dialogNuevoAlumno);
      resultado
        .then(result => {
          if (result.data.msj == "ok") this.previas = result.data.result;
        })
        .catch(error => {
          console.log(
            "listarAlumnos | methods | listarAlumnos |  catch: -> ",
            error
          );
        })
        .finally(() => {
          this.loadingDataPrevias = false;
        });
    },
    obtenerNotasMateriaPrevia(idPrevia, detalle) {
      let param = "idPrevia=" + idPrevia;
      let resultado = API.enviar("get", "obtenerDetallePrevia", param);
      //console.log(this.alumnos.length, this.dialogNuevoAlumno);
      resultado
        .then(result => {
          if (result.data.msj == "ok") {
            this.textoDetalleDialog = detalle;
            this.dialogDetallePrevia = true;
            this.previaDetalle = result.data.result;
          }
        })
        .catch(error => {
          console.log(
            "listarAlumnos | methods | listarAlumnos |  catch: -> ",
            error
          );
        })
        .finally(() => {});
    },
    mostrarDialogoDeCargaDeNota(idprevia, detalle) {
      this.dialogNotaPrevia = true;

      /* limpia campos */
      console.log(this.$refs);
      this.msj_error_visible = false;
      //this.$refs.n_nota.value = "";
      //this.$refs.n_fecha.value = "";
      //this.$refs.n_periodo.value = "";
      //this.$refs.n_libro_acta.value = "";
      //this.$refs.n_tomo.value = "";
      //this.$refs.n_folio.value = "";
      /*-------------- */

      this.textoDetalleDialog = detalle;

      //this.$refs.n_fecha.value = API.FECHA_ACTUAL;
      //this.$refs.n_periodo.value = API.PERIODO_ACTUAL;
      this.$refs.n_idprevia.value = idprevia;
    },
    guardarNotaDePrevia() {
      //this.dialogNotaPrevia = true;
      if (
        this.$refs.n_nota.value != "" &&
        this.$refs.n_nota.value >= 0 &&
        this.$refs.n_nota.value <= 10
      ) {
        let idPrevia = this.$refs.n_idprevia.value;
        let nota = this.formato_numero(this.$refs.n_nota.value);
        let libro_acta = this.$refs.n_libro_acta.value;
        let tomo = this.$refs.n_tomo.value;
        let folio = this.$refs.n_folio.value;
        //let fecha = this.$refs.n_fecha.date;
        let periodo = this.$refs.n_periodo.value;

        console.log("Nota: ", nota);
        console.log("idprevia: ", idPrevia);

        let params = "idPrevia=" + idPrevia;
        params += "&nota=" + nota;
        params += "&libro_acta=" + libro_acta;
        params += "&tomo=" + tomo;
        params += "&folio=" + folio;
        //params += "&fecha=" + fecha;
        params += "&periodo=" + periodo;

        let resultado = API.enviar("get", "guardarNotaDeMateriaPrevia", params);
        //console.log(this.alumnos.length, this.dialogNuevoAlumno);
        resultado
          .then(result => {
            if (result.data.msj == "ok") {
              this.dialogNotaPrevia = false;
              this.obtenerMateriasPrevias();
            }
          })
          .catch(error => {
            console.log(
              "materiasPrevias | methods | guardarNotaDePrevia |  catch: -> ",
              error
            );
          })
          .finally(() => {});
      } else {
        this.msj_error_visible = true;
      }
    },
    check() {
      //console.log(this.$refs.n_fecha.date);
    }
  },
  watch: {}
};
</script>

<style scoped>
.contenido {
  width: 100% !important;
}

.visible {
  display: block;
}

.oculto {
  display: none;
}

.header {
  margin-top: 30px;
  padding: 10px 0;
  font-size: 13px;
  font-weight: bold;
  padding-left: 5px;
  background-color: #ccc;
  opacity: 0.8;
}

.borde_inferior {
  border-bottom: solid 1px #000;
}

.btn_dialog {
  margin: 10px 0;
}

input {
  width: 70%;
  border: #ccc solid 1px;
  /*padding: 1px;*/
  text-align: center;
}

.deshabilitado {
  background: #dddddd;
}

.msj_error_nota {
  color: red;
  font-weight: bold;
}
</style>